/* wb-jdgm-badge.js (2026-09-30) — Judge.me-Badge-Text in der Shopsprache halten.
   Das Theme gibt die Karten-Badges serverseitig schon übersetzt aus (snippets/wb-jdgm-badge.liquid), aber Judge.mes
   Skript rendert sie nach dem Laden neu und schreibt seinen deutschen Text («725 Bewertungen») hinein. Hier wird der
   Text aus window.wbJdgmTexte (layout/theme.liquid, Locale-Keys judgeme.badge_*) zurückgesetzt — beim Laden und bei
   jeder späteren Änderung (Filter, Slider, Warenkorb-Flyout). Die Kaufbox regelt snippets/wb-bewertungszeile.liquid. */
(function () {
  var T = window.wbJdgmTexte;
  if (!T || !document.querySelector) return;

  /* 2026-10-02: Der Liquid-Filter t escapet Sonderzeichen (FR «Pas encore d&#39;avis»); über textContent gesetzt
     stünde die Entity sichtbar im Badge (live gesehen). Deshalb einmal dekodieren. */
  function dekod(s) {
    if (typeof s !== "string" || s.indexOf("&") < 0) return s;
    var t = document.createElement("textarea");
    t.innerHTML = s;
    return t.value;
  }
  T = { one: dekod(T.one), other: dekod(T.other), none: dekod(T.none) };

  function soll(anzahl) {
    var n = parseInt(anzahl, 10) || 0;
    if (n === 0) return T.none;
    if (n === 1) return T.one;
    return T.other.replace('__N__', String(n));
  }

  function setzen() {
    var badges = document.querySelectorAll('.jdgm-preview-badge .jdgm-prev-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.closest && b.closest('.product__info-container')) continue;
      var t = b.querySelector('.jdgm-prev-badge__text');
      if (!t) continue;
      var text = soll(b.getAttribute('data-number-of-reviews'));
      if (t.textContent.trim() !== text) t.textContent = text;
    }
  }

  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    /* setTimeout statt requestAnimationFrame: rAF läuft in Hintergrund-Tabs nicht (gemessen 2026-09-30). */
    setTimeout(function () { geplant = false; setzen(); }, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setzen);
  else setzen();
  window.addEventListener('load', setzen);

  if (window.MutationObserver) {
    new MutationObserver(planen).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
